import React from 'react'
import Student from './Student'

const Notice = () => {
  return (
    <div>
      <Student title='Notices' fieldname='Description' cata='Add Notice' link='add-notice' head='notice'/>
    </div>
  )
}

export default Notice
